module.exports = __webpack_public_path__ + "img/lvyou-1.0f6aab99.jpg";